module.exports = __webpack_public_path__ + "static/media/Shubhangi Khanna.968ecd49.png";